import React from 'react'
import { useTheme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

/**
 * Componente de botón genérico.
 * 
 * @param {Object} props Propiedades del botón en modo spread operator.
 * @returns {React.Component}
 */
export default function ButtonComponent({ withBorder = false, children, ...props }) {

    const theme = useTheme();
    const border = withBorder ? `1px solid ${theme.palette.primary.main}` : '';

    return (
        <Button style={{ border: border }} {...props}>{children}</Button>
    )
}
